import { AlphabetsDraftApi, useAPIQuery } from "melco-shared-logic";

export const useFontReferences = (fontId: string) => {
  return useAPIQuery(
    AlphabetsDraftApi,
    ["fontReferences", fontId],
    async (api) => api.userAlphabetReferences({ id: fontId })
  );
};
